// ExportToDecipherModal.tsx
import React from "react"
import { Modal, Typography } from "antd"
import ExportToDecipherOptionsForm from "./ExportToDecipherOptionsForm.component"
import { Project } from "stores/projectStore"
import { Variant } from "types/questionnaire.types"

/**
 * Props interface for the ExportToDecipherModal component
 */
interface ExportToDecipherModalProps {
  /** Function to retrieve the notes for the questionnaire */
  getQuestionnaireNotes: () => string[]
  /** The project data that will be exported */
  project: Project
  /** Determines if the modal is visible */
  isExportDecipherModalVisible: boolean
  /** Function to toggle the visibility of the modal */
  setExportDecipherModalVisible: (visible: boolean) => void
  /** The variants data that will be passed to the export form */
  variants: Variant[]
}

/**
 * ExportToDecipherModal component renders a modal for exporting a project to Decipher XML format.
 *
 * @component
 * @param props - The component props
 * @returns The rendered ExportToDecipherModal component
 */
const ExportToDecipherModal: React.FC<ExportToDecipherModalProps> = ({
  getQuestionnaireNotes,
  project,
  isExportDecipherModalVisible,
  setExportDecipherModalVisible,
  variants,
}) => {
  const { Title } = Typography

  return (
    <Modal
      open={isExportDecipherModalVisible}
      centered={true}
      footer={false}
      closable={false}
      destroyOnHidden={true}
    >
      <Title style={{ margin: 0, marginBottom: "0.5em" }} level={5}>
        Export To Decipher XML
      </Title>
      <ExportToDecipherOptionsForm
        getQuestionnaireNotes={getQuestionnaireNotes}
        project={project}
        variants={variants}
        setExportDecipherModalVisible={setExportDecipherModalVisible}
      />
    </Modal>
  )
}

export default ExportToDecipherModal
